import { useRouter } from 'next/router';
import styles from '../styles/pages/404.module.scss';

const Custom404 = () => {
  const router = useRouter();

  const goHome = () => {
    router.push('/');
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.h1}>404 - Página no encontrada</h1>
      <p className={styles.p}>
        Lo sentimos, la página que estás buscando no existe.
      </p>
      <button onClick={goHome} className={styles.button}>
        Volver al inicio
      </button>
    </div>
  );
};

export default Custom404;
